import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, forwardRef, HostBinding, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { RiskArea, RiskAreaFilters } from 'src/app/commons/models/risk-area.model';
import * as RiskAreaActions from 'src/app/store/actions/risk-area.actions';
import { AppState } from 'src/app/store/reducers';


export const RISK_AREA_FIELD_MAT_FORM_FIELD_CONTROL: any = {
  provide: MatFormFieldControl,
  useExisting: forwardRef(() => RiskAreaFieldComponent),
};

@Component({
  selector: "app-risk-area-field",
  templateUrl: "./risk-area-field.component.html",
  styleUrls: ["./risk-area-field.component.scss"],
  providers: [RISK_AREA_FIELD_MAT_FORM_FIELD_CONTROL],
  host: {
    "[class.floating]": "shouldLabelFloat",
    "[id]": "id",
  },
})
export class RiskAreaFieldComponent
  implements ControlValueAccessor, MatFormFieldControl<RiskArea> {
  private unsubscribe$ = new Subject<void>();
  private _value: RiskArea;
  private _disabled = false;

  private _required = false;

  get errorState(): boolean {
    return !this.ngControl.valid;
  }
  focused: boolean; //TODO
  controlType?: string = "riskArea-selection-field";
  autofilled?: boolean;
  riskAreaAriaDescribedBy?: string;


  @Input()
  riskAreaFilters: RiskAreaFilters;

  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    @Optional() @Self() public ngControl: NgControl
  ) {
    this.actions$
      .pipe(
        ofType(RiskAreaActions.riskAreaSelected),
        takeUntil(this.unsubscribe$),
        map(({ riskArea }) => (riskArea ? new RiskArea(riskArea) : null))
      )
      .subscribe((riskArea) => (this.value = riskArea));
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  stateChanges = new Subject<void>();
  id: string;

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  private _placeholder: string;

  get empty() {
    return !this.value;
  }

  @HostBinding("class.floating")
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }

  @Input()
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {
    //TODO
  }
  onContainerClick(event: MouseEvent): void {
    if (!this.disabled) {
      if ((event.target as Element).tagName.toLowerCase() != "mat-icon") {
        this.selectRiskArea();
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.stateChanges.complete();
  }

  selectRiskArea() {
    this.store$.dispatch(RiskAreaActions.selectRiskArea({ filters: this.riskAreaFilters }));
  }

  clearRiskArea() {
    this.value = null;
  }

  set value(value: RiskArea) {
    this._value = value;
    this.notifyValueChange();
    this.stateChanges.next();
  }

  get value(): RiskArea {
    return this._value;
  }

  onChange: (value) => {};
  onTouched: () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(obj: RiskArea): void {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
